import _ from 'lodash'

export function getDefaultPopupContainer (defaultPopupContainer: any) {
  return _.get(document.getElementsByClassName('air8-popup__container'), '0', defaultPopupContainer)
}
